import React, { useState, useEffect } from 'react';
import { reduce, filter as _filter, find, isEmpty, intersection } from 'lodash';
import classnames from 'classnames';

import { Story } from './Story';
import { Filter } from './Filter';

import { Segment, Header, Button, Dimmer } from 'semantic-ui-react';

export { name } from './stories.json';
export { Stories as renderer };

function Placeholder({ resetQuery, ...rest }) {
  const active = true;

  function handleClick(event, data) {
    resetQuery();
  }

  return (
    <Dimmer.Dimmable as={Segment} blurring dimmed={active}>
      <Dimmer active={active}>
        <Header as="h2" inverted>
          {'Nothing found :('}
        </Header>

        <Button primary onClick={handleClick}>
          {'Clear query'}
        </Button>
      </Dimmer>
    </Dimmer.Dimmable>
  );
}

export function Stories({ data, ...rest }) {
  const { attributes, innerBlocks, rendered } = data;
  const [stories, setStories] = useState([]);
  const [options, setOptions] = useState([]);
  const [filter, setFilter] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const { tagName, blockClass, prefix } = attributes;

  const BlockWrapper = tagName;

  useEffect(() => {
    const stories = _filter(innerBlocks, { blockName: 'cli/story' });
    const filter = find(innerBlocks, { blockName: 'cli/story-filter' });
    setStories(stories);
    setFilter(filter);
  }, []);

  function resetQuery() {
    setSelectedCategories([]);
  }

  const source = !isEmpty(selectedCategories)
    ? reduce(
        stories,
        (result, value, key) => {
          const { attributes } = value;
          const { relatedCategories } = attributes;

          const matchedIds = intersection(relatedCategories, selectedCategories);

          // console.log(`Related categories`);
          // console.log(relatedCategories);

          // console.log(`All related ids`);
          // console.log(allRelatedIds);

          // console.log(`Selected categories`);
          // console.log(selectedCategories);

          // console.log(`Matched ids`);
          // console.log(matchedIds);

          if (matchedIds.length > 0) {
            result.push(value);
          }

          return result;
        },
        [],
      )
    : [...stories];

  const storyList = source.map((story, index) => <Story key={index} data={story} />);

  const innerWrapClasses = classnames(`${blockClass}__wrap`, {});

  return (
    <BlockWrapper className={blockClass} {...rest}>
      <div className={innerWrapClasses}>
        {filter && (
          <Filter
            options={options}
            setOptions={setOptions}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            attributes={filter.attributes}
          />
        )}
        {storyList}
        {isEmpty(storyList) && <Placeholder resetQuery={resetQuery} />}
      </div>
    </BlockWrapper>
  );
}
